import Filter, {
  FilterFields,
  FilterRow,
  FilterText,
} from "../../../components/Filter/Filter.tsx";
import styles from "./GestionRessources.module.css";

type filtreRessource = {
  ressourceLibelle?: string;
};

export const initialFilterValues = {
  ressourceLibelle: "",
};

export const filterValuesToVariable = ({
  ressourceLibelle,
}: filtreRessource) => {
  const filter: filtreRessource = {};

  if (ressourceLibelle != null && ressourceLibelle.trim() !== "") {
    filter.ressourceLibelle = ressourceLibelle;
  }

  return filter;
};

const FiltreRessources = () => {
  return (
    <Filter>
      <FilterFields>
        <FilterRow>
          <div className={styles.filterItem}>
            <FilterText
              label=""
              aria-labelledby="recherche-ressource"
              placeholder="Rechercher par titre..."
              name="ressourceLibelle"
            />
          </div>
        </FilterRow>
      </FilterFields>
    </Filter>
  );
};

export default FiltreRessources;
